const cart = {
    init() {
        cart.create();
    },
    create() {
        
        $('body').on('click', '[data-cart-popup-close]', function(event) {
            event.preventDefault();
            $('.cart-popup').removeClass('on');
        });
    }
};

document.addEventListener("DOMContentLoaded", () => {
    cart.init();
});